import { gql } from '@apollo/client'

export const EXPORT_TRANSPORT_QUERY = gql`
  query TransportActivities(
    $first: Int
    $after: String
    $where: TransportActivitiesGraphQlFilterInput
    $order: [TransportActivitiesGraphQlSortInput!]
  ) {
    transportActivities(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        state
        resource
        temperatureConditions
        medium
        shortDescription
        countryId
        countryName
        countryISOCode
        regionIdentifier
        regionIdentifierId
        carbon
        waterUsage
        eutrophication
        processName
        processId
        description
        comment
        secondaryDataReferenceSourceType
        dataQualityReliabilityScore
        referencesSamplingYear
        referenceDataPublicationYear
        referenceSourcingCountry
        referenceCountryISOCode
        referenceRegionIdentifier
        dataQualityComment
        lastPublishedDate
        researcherName
        researcherEmail
        isVerified
        verificationComments
        verifiedByEmail
        verifiedByName
        verifiedOn
        updated
        lastUpdatedName
        userId
        userEmail
        refQuantity
        companyId
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
